import { render, staticRenderFns } from "./btn-text-primary.vue?vue&type=template&id=8edfeac8&scoped=true&"
import script from "./btn-text-primary.vue?vue&type=script&lang=js&"
export * from "./btn-text-primary.vue?vue&type=script&lang=js&"
import style0 from "./btn-text-primary.vue?vue&type=style&index=0&id=8edfeac8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edfeac8",
  null
  
)

export default component.exports